export function getCharacterCount(value: string | null | undefined) {
  return value?.length ?? 0;
}

export function formatCharacterCount(value: string | null | undefined, maxLength: number) {
  return `${getCharacterCount(value)}/${maxLength}`;
}

export function isCharacterLimitExceeded(value: string | null | undefined, maxLength: number) {
  return getCharacterCount(value) > maxLength;
}
